module.exports = __webpack_public_path__ + "static/img/kols19.0c21b97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/kols/kols19.png
// module id = pUOr
// module chunks = 0